document.addEventListener('DOMContentLoaded', function () {
    // Get the value of the data attribute
    let initVal = parseInt(12);
    let minusInvitVal = parseInt(12);
    // Check if it's not undefined or blank
    if (initVal !== undefined && initVal !== null ) {
        initVal = initVal; 
        minusInvitVal = initVal-1;
    }
  console.log('initVal', initVal)
  // console.log('checkCartInputValues', input.value)
  
    const cartItemQuantityInputs = document.querySelectorAll('.cart-item__quantity-input');

    // create a paragraph element with a class of 'alert' for the first input with value 1
    var lineItemAlert = document.createElement('p');
    lineItemAlert.classList.add('line-alert');
    lineItemAlert.style.backgroundColor = '#533117';
    lineItemAlert.style.color = '#fff';
    lineItemAlert.style.padding = '0.15rem';
    lineItemAlert.style.marginBottom = '5px';
    lineItemAlert.style.textAlign = 'center';
    lineItemAlert.style.marginTop = '10px';


    //// This only works on page Load, not on cart change?
    /////////////////////////////////////////////////////
    function checkCartInputValues() {
      
        var inputsWithValueOne = Array.from(cartItemQuantityInputs).filter(function (input) {
            return input.value === '1';
        });

        // Check if there are inputs with values between '2' and '7'
        var inputsBetweenTwoAndFive = Array.from(cartItemQuantityInputs).filter(function (input) {
            return input.value >= '2' && input.value <= minusInvitVal;
        });

        // Checks inputs for duplicate samples
        if (inputsWithValueOne.length > 1) {
            // Find the nearest parent element with the class 'cart-item' or adjust the selector as needed
            var firstCartItem = inputsWithValueOne[0].closest('.cart-item__column');

            // Find the element with the class 'cart-item__remove' within the firstCartItem
            var firstCartItemRemove = firstCartItem.querySelector('.cart-item__remove');

            lineItemAlert.textContent = '1 Sample per order, Please Adjust.';

            // Check if the alert is already present
            if (!firstCartItem.querySelector('.line-alert')) {
                // Insert the alert paragraph after the cart-item__remove element
                firstCartItem.insertBefore(lineItemAlert, firstCartItemRemove.nextSibling);

                // Use jQuery fadeIn effect
                $(lineItemAlert).fadeIn(1000);

                // Set a timeout to fade out and destroy the alert after a certain duration
                setTimeout(function () {
                    // Use jQuery fadeOut effect
                    $(lineItemAlert).fadeOut(1000, function () {
                        // Use jQuery remove to destroy the alert after it fades out
                        $(lineItemAlert).remove();
                    });
                }, 3000); // Adjust the duration as needed
            } 

        } else if (inputsBetweenTwoAndFive.length > 1) {

            // iterate over inputsBetweenTwoAndFive and check if any of them have a value between '2' and '5'
            inputsBetweenTwoAndFive.forEach(function (input) {
                
                    console.log("Input Value" + input.value);

                    // Find the nearest parent element with the class 'cart-item' or adjust the selector as needed
                    var cartItem = input.closest('.cart-item__column');

                    // Find the element with the class 'cart-item__remove' within the cartItem
                    var cartItemRemove = cartItem.querySelector('.cart-item__remove');

                    lineItemAlert.textContent = `Minimum Quantity is ${initVal}, Please Adjust.`;

                    // Check if the alert is already present
                    if (!cartItem.querySelector('.line-alert')) {
                        
                        // Insert the alert paragraph after the cart-item__remove element
                        cartItem.insertBefore(lineItemAlert, cartItemRemove.nextSibling);
                        // Use jQuery fadeIn effect
                        $(lineItemAlert).fadeIn(1000);

                        // Clear any existing timeouts
                        clearTimeout(input.timeoutId);

                        // Set a timeout to fade out and destroy the alert after a certain duration
                        input.timeoutId = setTimeout(function () {
                            // Use jQuery fadeOut effect
                            $(lineItemAlert).fadeOut(1000, function () {
                                // Use jQuery remove to destroy the alert after it fades out
                                $(lineItemAlert).remove();
                            });
                        }, 3000); // Adjust the duration as needed
                    } else  {
                        console.log('Alert already exists for input:', input.value);
                    }
                
            });
        } 
    }

    function updateCheckoutButton(count) {
        console.log('updateCheckoutButton called - Count is : ' + count);

        // Slide Cart Checkout Button
       const checkoutButton = document.querySelector('.custom-checkout-btn');
       const checkoutButtonCart = document.querySelector('.custom-checkout-cart');
      // Product Page Add To Cart Button
      console.log(checkoutButton);
      const hiddenAtcButton = document.getElementById('customily-cart-btn');
      
      if (checkoutButton !== null && checkoutButton !== undefined ) {
          //console.log("Checkout Button Exists")
        if($('.cart-item-list__body .item_tw-gourmet-gift-program').length > 0 || $('.cart-item-list__body .item_tw-sugar-gift-program').length > 0 || $('.cart-item-list__body .item_gourmet-gift-box-3oz').length > 0 ){
          
        }else{
          if (count === 0) {
              //console.log('Current button state: Disabled = ', checkoutButton.disabled);
              //console.log('Enabling Checkout Button');

            $('.custom-checkout-btn')
            .prop('disabled', false)
            .text('CHECK OUT NOW')
            .removeClass('checkout-alert')
            .attr('href', '/checkout');
              //console.log('New button state: Disabled = ', checkoutButton.disabled);  
              //console.log('Count is Still : ' + count);
            
          } else if (count === 1) {
              //console.log('Current button state: Disabled = ', checkoutButton.disabled);
              //console.log('Disabling Checkout Button');

            $('.custom-checkout-btn')
            .prop('disabled', true)
            .text(`Please Adjust Quantities, Minimum order of ${initVal}.\n 1 Sample per order.`)
            .addClass('checkout-alert')
            .removeAttr('href');

              console.log('New button state: Disabled = ', checkoutButton.disabled);
              console.log('Count is Still : ' + count);
            
          } else {
              console.log('Error Updating Checkout Button');
          }
        }
      } else {
          console.log("Checkout Button Not found");
      }

        if (checkoutButtonCart !== null && checkoutButtonCart !== undefined) {
          //console.log("Checkout Button Exists")
          if (count === 0) {
              //console.log('Current button state: Disabled = ', checkoutButtonCart.disabled);
              //console.log('Enabling Checkout Button');

            $('.custom-checkout-cart')
            .prop('disabled', false)
            .text('CHECK OUT NOW')
            .removeClass('checkout-alert');
              //console.log('New button state: Disabled = ', checkoutButtonCart.disabled);  
              //console.log('Count is Still : ' + count);
            
          } else if (count === 1) {
              //console.log('Current button state: Disabled = ', checkoutButtonCart.disabled);
              //console.log('Disabling Checkout Button');

            $('.custom-checkout-cart')
            .prop('disabled', true)
            .text(`Please Adjust Quantities, Minimum order of ${initVal}.\n 1 Sample per order.`)
            .addClass('checkout-alert');
           
              // console.log('New button state: Disabled = ', checkoutButtonCart.disabled);
              // console.log('Count is Still : ' + count);
            
          } else {
              console.log('Error Updating Checkout Button');
          }
      } else {
          console.log("Checkout Button Not found");
      } 
    }

    // Checks for duplicate samples and invalid quantities
    async function countItemsWithQuantityOne() {
        try {
            const response = await fetch('/cart.js');
            const jsonData = await response.json();

            const count = (() => {
                let quantityOneCount = 0;
                for (let item of jsonData.items) {
                  var gift_contains = false;
                  if (item.title.includes('Gift Box')) {
                        gift_contains = true;
                  } 
                    if (item.quantity === 1) {
                        quantityOneCount++;
                        //console.log('Number Of Samples' + quantityOneCount);
                        if (quantityOneCount >= 2) return 1;
                    } else if (item.quantity >= 2 && item.quantity <= minusInvitVal && gift_contains == false) {
                        return 1;
                    }
                }
                return 0; // return 0 if none of the conditions are met
            });
            return count();
        } catch (error) {
            console.error('Error fetching cart data:', error);
            return 0; // Return 0 if there's an error fetching data
        }
    }

    // Checks if current Cart is valid, inputs on cart and updates checkout button
    async function checkCartContents() {
        try {
            const count = await countItemsWithQuantityOne();
            updateCheckoutButton(count);
            //checkCartInputValues()
        }
        catch (error) {
            console.error('Error checking cart contents:', error);
        }

        finally {
            //console.log('checkCartContents complete')
            //checkCartInputValues();
        }
    }

    document.addEventListener('on:cart-drawer:after-open', (event) => {
      setTimeout(function () {
        console.log('Theme Event Triggered - open-cart-drawer');
        checkCartContents()
        }, 1000);
    });

  

  document.addEventListener('on:cart:after-merge', (event) => {
      setTimeout(function () {
        //console.log('Theme Event Triggered - cartchanged');
        checkCartContents();
      }, 1000)
  });

    // Check Each Page Load (solve cart page issue?)
    setTimeout(function () {
        //console.log('CheckCartContents called on page load ');
        checkCartContents();
    }, 2000);


    // Block The Cart Page as an additional measure
    if (window.location.pathname.includes('/cart')) {
        //window.location.href = '/';
    } 
});
